module.exports = __webpack_public_path__ + "img/10.46cb58d6.jpg";